<!-- src/components/course/CertificateDesignerWrapper.vue -->
<template>
  <div class="certificate-designer-wrapper">
    <iframe
      ref="iframeRef"
      class="certificate-designer-wrapper__frame"
      :src="iframeSrc"
      title="Certificate Designer"
      @load="handleFrameLoad"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'

const props = defineProps({
  initialTemplate: {
    type: [Object, String],
    default: null
  },
  courseId: {
    type: [Number, String],
    default: null
  },
  courseName: {
    type: String,
    default: ''
  },
  certificateName: {
    type: String,
    default: ''
  },
  mode: {
    type: String,
    default: 'create'
  }
})

const emit = defineEmits(['save', 'cancel'])

const iframeRef = ref(null)
const iframeReady = ref(false)
const iframeSrc = '/certificate-designer.html'
let lastFrameHeight = 0

const postToIframe = (type, payload) => {
  const target = iframeRef.value?.contentWindow
  if (!target) return

  target.postMessage({ type, payload }, window.location.origin)
}

const sendProps = () => {
  // Сериализуем initialTemplate чтобы избежать DataCloneError
  let template = props.initialTemplate
  if (template && typeof template === 'object') {
    try {
      template = JSON.stringify(template)
    } catch (e) {
      console.error('Error serializing template:', e)
      template = null
    }
  }
  
  postToIframe('certificate-designer:props', {
    initialTemplate: template,
    courseId: props.courseId,
    courseName: props.courseName,
    certificateName: props.certificateName,
    mode: props.mode
  })
}

const handleFrameLoad = () => {
  if (!iframeReady.value) {
    sendProps()
  }
}

const handleMessage = event => {
  if (event.origin !== window.location.origin) return

  const { type, payload } = event.data || {}
  if (type === 'certificate-designer:ready') {
    iframeReady.value = true
    sendProps()
    return
  }
  if (type === 'certificate-designer:save') {
    emit('save', payload)
    return
  }
  if (type === 'certificate-designer:cancel') {
    emit('cancel')
    return
  }
  if (type === 'certificate-designer:height') {
    const nextHeight = Number(payload?.height)
    if (!Number.isFinite(nextHeight) || nextHeight <= 0) return
    if (Math.abs(nextHeight - lastFrameHeight) < 2) return
    lastFrameHeight = nextHeight
    if (iframeRef.value) {
      iframeRef.value.style.height = `${nextHeight}px`
    }
  }
}

onMounted(() => {
  window.addEventListener('message', handleMessage)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage)
})

watch(
  () => [props.initialTemplate, props.courseId, props.courseName, props.mode],
  () => {
    if (iframeReady.value) {
      sendProps()
    }
  }
)
</script>

<style scoped>
.certificate-designer-wrapper {
  width: 100%;
  max-width: 1800px;
  min-height: 100vh;
  /* background-color: #f3f4f6; */
  border-radius: 20px;
  overflow: hidden;
  margin: 0 auto;
}

.certificate-designer-wrapper__frame {
  width: 100%;
  min-height: 100vh;
  border: 0;
  display: block;
}
</style>
